import React from "react";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";

const Footer = () => {
  return (
    <div
      style={{
        backgroundColor: "#333",
        color: "#fff",
        padding: "20px 0",
        fontFamily: `"Myriad Pro", "Source Sans Pro", system-ui, sans-serif`,
        fontSize: "14px",
      }}
    >
      {/* Centered content wrapper */}
      <div
        style={{
          maxWidth: "1500px",
          margin: "0 auto",
          padding: "0 20px",
          display: "flex",
          flexDirection: "column",
          gap: "10px",
        }}
      >
        {/* Top Section */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            flexWrap: "wrap",
            alignItems: "center",
          }}
        >
          {/* Left Section */}
          <a
            href="https://www.danfoss.com"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              color: "#fff",
              textDecoration: "none",
              fontWeight: "bold",
              display: "flex",
              alignItems: "center",
              gap: "5px",
              fontFamily: `"Myriad Pro", "Source Sans Pro", system-ui, sans-serif`,
            }}
          >
            About Danfoss
            <OpenInNewIcon style={{ fontSize: "16px" }} />
          </a>

          {/* Right Section */}
          <button
            style={{
              backgroundColor: "#fff",
              color: "#333",
              border: "none",
              padding: "10px 20px",
              fontSize: "14px",
              fontWeight: "bold",
              cursor: "pointer",
              borderRadius: "2px",
              fontFamily: `"Myriad Pro", "Source Sans Pro", system-ui, sans-serif`,
              marginTop: "10px",
            }}
          >
            Contact Us
          </button>
        </div>

        {/* White Line */}
        <div
          style={{
            width: "100%",
            height: "1px",
            backgroundColor: "#fff",
            margin: "5px 0",
          }}
        ></div>

        {/* Bottom Section */}
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            gap: "30px",
          }}
        >
          {["Where to Buy?", "Privacy Policy", "Terms of Use", "Cookies"].map(
            (text) => (
              <a
                key={text}
                href="#"
                style={{
                  color: "#fff",
                  textDecoration: "none",
                  fontFamily: `"Myriad Pro", "Source Sans Pro", system-ui, sans-serif`,
                }}
              >
                {text}
              </a>
            )
          )}
        </div>
      </div>
    </div>
  );
};

export default Footer;
